import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import ServiceList from "../pages/services/ServiceList";
import Contact from "../pages/Contact";
import Career from "../pages/Career";
import FAQ from "../pages/FAQ";
import BlogList from "../pages/blogs/BlogList";
import BlogDetail from "../pages/blogs/BlogDetail";
import NotFound from "../pages/NotFound";
import { ROUTES } from "./path";
import PrivacyPolicy from "../pages/components/PrivacyPolicy";
import TermsConditions from "../pages/components/TermsConditions";

function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTES.HOME} element={<Home />} />
      <Route path={ROUTES.ABOUT} element={<About />} />
      <Route path={ROUTES.SERVICE} element={<ServiceList />} />
      <Route path={ROUTES.CONTACT} element={<Contact />} />
      <Route path={ROUTES.CAREER} element={<Career />} />
      <Route path={ROUTES.FAQ} element={<FAQ />} />
      <Route path={ROUTES.BLOG} element={<BlogList />} />
      <Route path={ROUTES.BLOG_DETAIL} element={<BlogDetail />} />
      <Route path={ROUTES.PRIVACY} element={<PrivacyPolicy />} />
      <Route path={ROUTES.TERMS} element={<TermsConditions />} />
      <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
      <Route
        path={ROUTES.REST_PATH}
        element={<Navigate to={ROUTES.NOT_FOUND} replace />}
      />
    </Routes>
  );
}

export default AppRoutes;
